import React, { FunctionComponent, useEffect, useMemo, useState } from "react";
import Select, { ValueType } from "react-select";
import {
  EvidencePeriodData,
  Gender,
  Race,
  RaceInfo,
  ReactSelectOption,
  demographicToggleList,
  genderList,
} from "../../../../../../../store/onboarding/types";
import { Grade } from "../../../../../../../store/groups/types";
import { ApplicationState } from "../../../../../../../store";
import { bindActionCreators, Dispatch } from "redux";
import { changeDataGradesFilter, changeELLFilter, changeFreeOrReducedLunchFilter, changeGenderFilter, changeRaceFilter, changeRaceOtherFilter, changeSLDFilter, changeSpecialEducationFilter } from "../../../../../../../store/dataFilter/actions";
import { connect, useDispatch, useSelector } from "react-redux";
import { USState } from "../../../../../States";
import { Form, FormControl } from "react-bootstrap";
import { getRaceInfo } from "../../../../../../../store/onboarding/actions";

type StateProps = {
  raceFilter: string[];
  raceOtherFilter: string[];
  genderFilter: string[];
  specialEducationFilter: boolean | undefined;
  ellFilter: boolean | undefined;
  sldFilter: boolean | undefined;
  freeOrReducedLunchFilter: boolean | undefined;
  raceInfo: RaceInfo;
  isLoading: {
    getRaceInfo: boolean;
  };
  errors: {
    getRaceInfo?: string;
  };
};

type DispatchProps = {
  changeRaceFilter: (raceFilter?: string[]) => any;
  changeRaceOtherFilter: (raceOtherFilter?: string[]) => any;
  changeGenderFilter: (genderFiler?: string[]) => any;
  changeSpecialEducationFilter: (specialEducation:boolean | undefined) => any;
  changeELLFilter: (ELL:boolean | undefined) => any;
  changeSLDFilter: (SLD:boolean | undefined) => any;
  changeFreeOrReducedLunchFilter: (freeOrReducedLunch:boolean | undefined) => any;
};

type OwnProps = {
  fromDataFilter?: boolean;
}

type Props = StateProps & DispatchProps & OwnProps;

const DemographicsFilter: FunctionComponent<Props> = ({
  raceFilter,
  raceOtherFilter,
  genderFilter,
  specialEducationFilter,
  ellFilter,
  sldFilter,
  freeOrReducedLunchFilter,
  isLoading,
  raceInfo,
  changeRaceFilter,
  changeRaceOtherFilter,
  changeGenderFilter,
  changeSpecialEducationFilter,
  changeELLFilter,
  changeSLDFilter,
  changeFreeOrReducedLunchFilter,
  fromDataFilter
}) => {
  const dispatch = useDispatch();
  const currentDataPeriod = useSelector(
    (s: ApplicationState) => s.onboarding.currentDataPeriod
  );
  // const [race, setRace] = useState<number | undefined>();
  // const [raceOtherValue, setRaceOtherValue] = useState<string | undefined>();
  // const [gender, setGender] = useState<string | undefined>();
  const [specialEducation, setSpecialEducation] = useState<boolean | undefined>();
  const [ell, setELL] = useState<boolean | undefined>();
  const [sld, setSLD] = useState<boolean | undefined>();
  const [freeOrReducedLunch, setFreeOrReducedLunch] = useState<boolean | undefined>();

  
  useEffect(() => {
    setSpecialEducation(specialEducationFilter)
    setELL(ellFilter)
    setSLD(sldFilter)
    setFreeOrReducedLunch(freeOrReducedLunchFilter)
  },[])
  
  useEffect(() => {
    changeSpecialEducationFilter(specialEducation);
    changeELLFilter(ell);
    changeSLDFilter(sld);
    changeFreeOrReducedLunchFilter(freeOrReducedLunch);
  },[specialEducation,
    ell,
    sld,
    freeOrReducedLunch])

  useEffect(() => {
    if(currentDataPeriod){
      dispatch(getRaceInfo(currentDataPeriod.id))
    }
  },[currentDataPeriod])

  const handleRaceFilterChange = (
    options: ValueType<ReactSelectOption<any>, any>
  ) => {
        if (options) {
          if(raceInfo.races.filter((race) => (options as ReactSelectOption<any>[]).some((value) => value.value == race)).length){
            const races: any[] = (options as ReactSelectOption<any>[])?.map((option) => option.value) ?? [];
            changeRaceFilter(races);
            changeRaceOtherFilter();
          } else if(
                  raceInfo.race_other_values.length 
                  && raceInfo.race_other_values.filter((otherRace) => (options as ReactSelectOption<any>[]).some((value) => value.value == otherRace)).length
          ) {
            const otherRaces: any[] = (options as ReactSelectOption<any>[])?.map((option) => option.value) ?? [];
            changeRaceOtherFilter(otherRaces);
            changeRaceFilter();
          }
        } else {
          changeRaceFilter();
          changeRaceOtherFilter();
        }
    };
  
  const handleGenderFilterChange = (
    option: ValueType<ReactSelectOption<string>, any>
  ) => {
    if (option) {
      const genders: any[] = (option as ReactSelectOption<Gender>[])?.map((gender) => gender.value) ?? [];
      changeGenderFilter(genders);
    } else {
      changeGenderFilter();
    }
  }

  const handleSpecialEducationFilterChange = (
    values: ValueType<ReactSelectOption<boolean>, false>
  ) => {
    if (values) {
      setSpecialEducation(
        (values as ReactSelectOption<boolean>).value
      );
    } else {
      setSpecialEducation(undefined);
    }
  }

  const handleELLFilterChange = (
    values: ValueType<ReactSelectOption<boolean>, false>
  ) => {
    if (values) {
      setELL(
        (values as ReactSelectOption<boolean>).value
      );
    } else {
      setELL(undefined);
    }
  }

  const handleSLDFilterChange = (
    values: ValueType<ReactSelectOption<boolean>, false>
  ) => {
    if (values) {
      setSLD(
        (values as ReactSelectOption<boolean>).value
      );
    } else {
      setSLD(undefined);
    }
  }

  const handleFreeOrReduceLunchFilterChange = (
    values: ValueType<ReactSelectOption<boolean>, false>
  ) => {
    if (values) {
      setFreeOrReducedLunch(
        (values as ReactSelectOption<boolean>).value
      );
    } else {
      setFreeOrReducedLunch(undefined);
    }
  }

  const options: ReactSelectOption<any>[] = useMemo(() => {
    if(raceInfo?.races.length) {
      return raceInfo.races.concat(raceInfo.race_other_values)
        .map((race) => ({
          value: race,
          label: race,
        }));
    } else {
      return [];
    }
  }, [raceInfo]);
  const genderOptions: ReactSelectOption<string>[] = useMemo(() => genderList, []);
  const demographicToggleOptions: ReactSelectOption<any>[] = useMemo(() => demographicToggleList, []);

  return (
    <>
      {fromDataFilter ? 
        <>
          <div className="mb-2">
            <h4 className="font-weight-bold m-0">Race(s)</h4>
            <Select
              isMulti
              isClearable
              className="flex-1"
              placeholder="Not Set"
              isLoading={isLoading.getRaceInfo}
              options={options}
              value={options.filter((r) => raceFilter?.includes(r.value) || raceOtherFilter?.includes(r.value))}
              onChange={handleRaceFilterChange}
            />
          </div> 
          <div className="mb-2">
            <h4 className="font-weight-bold m-0">Gender(s)</h4>
            <Select
                isMulti
                isClearable
                className="flex-1"
                placeholder="Not Set"
                options={genderOptions}
                value={genderOptions.filter((g) => genderFilter?.includes(g.value))}
                onChange={handleGenderFilterChange}
              />
          </div>
        </>
      : "" }
      <div className="mb-2">
        <h4 className="font-weight-bold m-0">Special Education</h4>
        <Select
            isClearable
            className="flex-1"
            placeholder="Not Set"
            options={demographicToggleOptions}
            value={demographicToggleOptions.find((d) => d.value == specialEducation)}
            onChange={handleSpecialEducationFilterChange}
          />
      </div>
      {fromDataFilter ?
        <div className="mb-0">
          <h4 className="font-weight-bold m-0">Free or Reduced Lunch</h4>
          <Select
              isClearable
              className="flex-1"
              placeholder="Not Set"
              options={demographicToggleOptions}
              value={demographicToggleOptions.find((d) => d.value == freeOrReducedLunch)}
              onChange={handleFreeOrReduceLunchFilterChange}
            />
        </div> 
      : ""}
      <div className="mb-0 row">
        <div className={`${fromDataFilter ? "col-6 pr-0" : "col-12 pb-2"}`}>
          <h4 className="font-weight-bold m-0">ELL</h4>
          <Select
              isClearable
              placeholder="Not Set"
              options={demographicToggleOptions}
              value={demographicToggleOptions.find((d) => d.value == ell)}
              onChange={handleELLFilterChange}
            />
        </div>
        <div className={`${fromDataFilter ? "col-6 pl-1" : "col-12 pb-2"}`}>
        <h4 className="font-weight-bold m-0">SLD</h4>
        <Select
            isClearable
            placeholder="Not Set"
            options={demographicToggleOptions}
            value={demographicToggleOptions.find((d) => d.value == sld)}
            onChange={handleSLDFilterChange}
          />
          
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ dataFilter, onboarding }: ApplicationState): StateProps => {
  return {
    raceFilter: dataFilter.raceFilter,
    raceOtherFilter: dataFilter.raceOtherFilter,
    genderFilter: dataFilter.genderFilter,
    specialEducationFilter: dataFilter.specialEducationFilter,
    ellFilter: dataFilter.ellFilter,
    sldFilter: dataFilter.sldFilter,
    freeOrReducedLunchFilter: dataFilter.freeOrReducedLunchFilter,
    raceInfo: onboarding.raceInfo,
    isLoading: {
      getRaceInfo: onboarding.isLoading.getRaceInfo
    },
    errors: {
      getRaceInfo: onboarding.errors.getRaceInfo
    },
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps =>
  bindActionCreators(
    {
      changeRaceFilter : changeRaceFilter,
      changeRaceOtherFilter : changeRaceOtherFilter,
      changeGenderFilter : changeGenderFilter,
      changeSpecialEducationFilter : changeSpecialEducationFilter,
      changeELLFilter : changeELLFilter,
      changeSLDFilter : changeSLDFilter,
      changeFreeOrReducedLunchFilter : changeFreeOrReducedLunchFilter,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DemographicsFilter);
